(() => {
  if (customElements.get('slider-component')) {
    return;
  }

  class SliderComponent extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }
  
    connectedCallback() {
      this.initSlider();
    }
  
    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy();
      }
    }
  
    initSlider() {
      const container = this.querySelector('.swiper-container');
      if (!container) return;
  
      const paginationSelector = this.querySelector('.swiper-pagination');
      const prevButtonSelector = this.querySelector('.swiper-button-prev');
      const nextButtonSelector = this.querySelector('.swiper-button-next');
      const autoplay = this.dataset.autoplay === 'true';
  
      this.swiper = new Swiper(container, {
        slidesPerView: 1,
        spaceBetween: 16,
        autoHeight: true,
        loop: true,
        pagination: {
          el: paginationSelector,
          clickable: true,
        },
        navigation: {
          nextEl: nextButtonSelector,
          prevEl: prevButtonSelector,
        },
        autoplay: autoplay ? {
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        } : false,
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 16,
          }
        }
      });
    }
  }  

  customElements.define('slider-component', SliderComponent);

  // Handle Shopify section updates
  document.addEventListener('shopify:section:load', (event) => {
    const sliderComponent = event.target.querySelector('slider-component');
    if (sliderComponent) {
      // Force re-initialization by removing and re-adding the component
      const newSliderComponent = sliderComponent.cloneNode(true);
      sliderComponent.parentNode.replaceChild(newSliderComponent, sliderComponent);
    }
  });
})();